export const WhatsAppConversationStatus = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  WAITING: 'WAITING',
  CLOSED: 'CLOSED',
} as const;

export type WhatsAppConversationStatus =
  (typeof WhatsAppConversationStatus)[keyof typeof WhatsAppConversationStatus];

export const WhatsAppMessageDirection = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
  SYSTEM: 'SYSTEM',
} as const;

export type WhatsAppMessageDirection =
  (typeof WhatsAppMessageDirection)[keyof typeof WhatsAppMessageDirection];

/** Agrupador virtual para contactos sin cuenta SIPAE. */
export const WHATSAPP_NO_COMPANY_ID = '__NO_COMPANY__';
export const WHATSAPP_NO_COMPANY_LABEL = 'Sin empresa';

export type WhatsAppDeliveryStatus = 'SENT' | 'DELIVERED' | 'READ' | 'FAILED';

export interface WhatsAppMessage {
  id: string;
  conversationId: string;
  direction: WhatsAppMessageDirection;
  body: string;
  sentAt: string;
  senderName?: string;
  templateCode?: string | null;
  deliveryStatus?: WhatsAppDeliveryStatus | null;
  errorDetail?: string | null;
}

export interface WhatsAppTraceEvent {
  id: string;
  at: string;
  label: string;
  detail?: string;
}

/** Contacto del directorio WhatsApp: como máximo una empresa, o ninguna. */
export interface WhatsAppDirectoryContact {
  id: string;
  phone: string;
  displayName?: string;
  email?: string;
  /** null = agrupador "Sin empresa" */
  companyId: string | null;
  companyName: string | null;
  active: boolean;
  registeredAt?: string;
}

export interface WhatsAppCompanyGroup {
  id: string;
  name: string;
}

/** Snapshot embebido en la conversación (derivado del directorio). */
export interface WhatsAppContact {
  contactId?: string;
  phone: string;
  displayName?: string;
  email?: string;
  identified: boolean;
  registeredAt?: string;
  companyId?: string | null;
  companyName?: string | null;
}

export interface WhatsAppAgentSummary {
  id: string;
  fullName: string;
  online: boolean;
  paused?: boolean;
  openConversations?: number;
}

export interface WhatsAppConversation {
  id: string;
  contact: WhatsAppContact;
  status: WhatsAppConversationStatus;
  assignedAgentId?: string | null;
  assignedAgentName?: string | null;
  lastMessagePreview: string;
  lastMessageAt: string;
  waitingMinutes?: number;
  windowHoursRemaining?: number | null;
  origin?: string;
  channel?: string;
  intakeId?: string | null;
  intakeLabel?: string | null;
  /** Empresa del Intake asociado (manda cuando hay Intake). */
  intakeCompanyId?: string | null;
  intakeCompanyName?: string | null;
  notes?: string;
  /** Hubo mensaje saliente y el contacto aún no responde. */
  awaitingContactReply?: boolean;
  /** true cuando messages/trace vienen del detalle (no del listado). */
  detailLoaded?: boolean;
  messages: WhatsAppMessage[];
  trace: WhatsAppTraceEvent[];
}

export type WhatsAppInboxTab = 'NEW' | 'IN_PROGRESS' | 'CLOSED' | 'ALL';

export type WhatsAppMockIntake = WhatsAppIntakeOption;

export interface WhatsAppIntakeOption {
  id: string;
  label: string;
  companyId: string;
  companyName: string;
  employeeName: string;
  phoneHint?: string;
}

/** Plantilla aprobada por Meta (solo lectura en SIPAE; no se crean aquí). */
export interface WhatsAppApprovedTemplate {
  id: string;
  name: string;
  language: string;
  category: string;
  body: string;
  status: 'APPROVED';
}

export interface WhatsAppIntakePrefill {
  accountId?: string;
  accountName?: string;
  lockAccount?: boolean;
  mobilePhone?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  email?: string;
}
